<template>
  <div>
    <TemplateRiskInput
      :with-none="true"
      v-model="innerValue" />
  </div>
</template>
<script>
import TemplateRiskInput from '@components/input/TemplateRiskInput';
import { mapMutations } from 'vuex';

export default {
  name: 'GenderFilter',
  components: {
    TemplateRiskInput
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    field: {
      type: String,
      required: true
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.setFilter({ key: this.field, value: val });
        if (val !== 0) {
          this.$emit('filter', () => (x) => x[this.field] === val);
        } else {
          this.$emit('filter', () => () => true);
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      setFilter: 'dataTableFilters/setFilter'
    })
  },
  mounted() {
    this.innerValue = this.$store.state.dataTableFilters.filters[this.field] || this.value;
  }
};
</script>
<style>

</style>
